import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_New_Task,
  Get_All_Tasks,
  Get_Error,
  Get_Specific_Task,
  Update_Specififc_Task,
} from '../Types';

export const Add_Task_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/UsersTasks`, body);

    dispatch({
      type: Add_New_Task,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_All_Tasks_For_User_Action = (userid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/UsersTasks?userId=${userid}`);

    dispatch({
      type: Get_All_Tasks,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_specific_Task_For_User_Action = (taskid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/UsersTasks/${taskid}`);

    dispatch({
      type: Get_Specific_Task,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const update_specific_Task_For_User_Action = (docementid, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/UsersTasks/${docementid}`, body);

    dispatch({
      type: Update_Specififc_Task,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
